export const formatCurrency = (value = 0) => {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "USD",
  }).format(value);
};

export const formatUSD = (value) => {
  if (value === null || value === undefined) return "—";
  if (typeof value === "object") return "—";
  const n = parseFloat(String(value).replace(/[^0-9.\-]/g, ""));
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};

export const formatQty = (q = 0) => String(q);
